// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 97 ? "npm.regenerator-runtime" : chunkId) + "." + {"97":"7d2991b4","414":"f2c03703"}[chunkId] + ".chunk.js";
};